import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CodeMirror from 'codemirror'
import "codemirror/lib/codemirror.css"
import "./mode"
import "./hint"
import "codemirror/addon/runmode/runmode"
import * as textutils from "./textutils"
import TextEditor from './TextEditor'

export default class LazyTextEditor extends TextEditor {
	constructor(props) { super(props) }
    
    blur(){ if(this.cm) super.blur() }

    componentDidUpdate(){
    	if(this.cm){
    		super.componentDidUpdate()
    	}else if(this.lastRenderedText != this.props.text){
            this.mountLazy()
        }
    }

    mountLazy(){
        var el = ReactDOM.findDOMNode(this);
        el.innerHTML = ''; // reset the stage
        var target = document.createElement('div')
        target.className = 'CodeMirror-lines'
        el.appendChild(target)
        var {text} = this.props;
        text = text || ''
        this.lastRenderedText = text;

        var mode = this.props.line.id == '__root__' ? 'rootmode' : 'leafmode';
        if(!quark.EDGE_AUTOCOLON && this.props.line.type == 'edge'){
            mode = 'edgemode'
        }
        

        CodeMirror.runMode(text, mode, target)
        
        ;[].slice.call(target.querySelectorAll('.cm-entity')).forEach(ent => {
            var match = /^(.*)<ref-(.*?)>(.*)$/.exec(ent.textContent);
            if(match){
                var newspan = document.createElement('span')
                newspan.className = 'cm-entity'
                newspan.appendChild(document.createTextNode(match[1]))
                newspan.appendChild(this.createToken(match[2]))
                newspan.appendChild(document.createTextNode(match[3]))
                ent.parentNode.replaceChild(newspan, ent)
            }
        })

        var span = document.createElement('span')
        span.className = 'zoom-in'
        span.innerHTML = '»'
        span.title = 'Hit Cmd-Enter/Ctrl-Enter to navigate'
        var line = this.props.line;
        span.onclick = function(){
            quark.set_root_text(quark.tok(line.id))
            globalUpdate()
        }
        target.appendChild(span)

        var isRoot = line.id == '__root__';
        target.classList.toggle('has-children', 
            !isRoot 
            && line.type == 'text' 
            && quark.enlist(line).length > 0
        )
        // console.log('derp', span, target)

        this.highlightEntities()


    }

    onMouseEnter(){ this.getCM() }

    componentDidMount(){
        if(this.props.lazy){
            this.mountLazy()
        }else{
            this.mountCodeMirror()
        }
    }

    componentWillUnmount(){
    	if(this.cm) super.componentWillUnmount();
    }

    render(){
        return <div 
            className="tachyon-input" 
            onMouseEnter={this.onMouseEnter.bind(this)} />
    }
}


// WEBPACK FOOTER //
// ./src/editor/LazyTextEditor.jsx